import React, {useEffect} from 'react';
import {
    View,
    Text,
    Image,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    Platform,
    Linking
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/simulacaoSucessoStyles';
import { useLogScreen } from '../useLogScreen';
export default function BaixarDocGeradorWeb({ route }) {
    useLogScreen('BaixarDocumento');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Baixar Documento';
            }, 100);
        }
    }, []);
    const navigation = useNavigation();
    const { imprimir_link, imprimir_link_pdf, imprimir_link_docx, usuario_id } = route.params || {};

    return (
        <BaseWeb>
            {(userInfo) => (
                <KeyboardAvoidingView
                    style={{ flex: 1 }}
                    behavior={Platform.OS === 'ios' ? 'padding' : undefined}
                    enabled={Platform.OS !== 'web'}
                >
                    <ScrollView contentContainerStyle={styles.container}>
                        <Image
                            source={require('../assets/img/stape6_laranja.png')}
                            style={styles.image}
                            resizeMode="contain"
                        />

                        <Text style={styles.title}>Documento criado com sucesso!</Text>
                        <Text style={styles.subtext}>Seu documento foi gerado com sucesso e enviada para o e-mail {userInfo.email}. Caso prefira, você pode baixá-la usando o botão abaixo.</Text>

                        <TouchableOpacity onPress={() => navigation.navigate('HomeWeb', { usuario_id })}>
                            <Text style={styles.linkText}>Continuar</Text>
                        </TouchableOpacity>

                        <TouchableOpacity style={styles.button} onPress={() => Linking.openURL(imprimir_link_docx)}>
                            <Text style={styles.buttonText}>Baixar Word</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.button} onPress={() => Linking.openURL(imprimir_link_pdf)}>
                            <Text style={styles.buttonText}>Baixar PDF</Text>
                        </TouchableOpacity>
                    </ScrollView>
                </KeyboardAvoidingView>
            )}
        </BaseWeb>
    );
}
